import React, { Component } from 'react';
import Category from './category.js';



class Categories extends Component {

	

  	render() {
		//let config =  	this.props.config;
		let cats = this.props.config.categories;
		
		//console.log('Yo Categories config: ', config);
		return (
			<div className="categories">
				{cats.map(function(category, i){
					return <Category category={category} key={i} />;
				})}
			</div>

  		)
  	}
}

export default Categories;
